import includes from 'lodash/includes'

export const brandCurrencyPrefixes = {
  AMTRAK: '$',
  AVAU: '$',
  AVUK: '£',
  AVCA: '$',
  AVNZ: '$',
  AVSG: '$',
  RAILBOOKER: '£',
  RBCA: '$',
  RBAU: '$',
  RBUS: '$',
  RBNZ: '$',
  RBSG: '$',
}

export const brandCurrencySuffixes = {
  AVAU: 'AUD',
  AVCA: 'CAD',
  AVNZ: 'NZD',
  AVSG: 'USD',
  RBCA: 'CAD',
  RBAU: 'AUD',
  RBNZ: 'NZD',
  RBSG: 'USD',
}

export const clientIds = {
  AMTRAK: 'amtrak',
  AVAU: 'avau',
  AVUK: 'avuk',
  AVCA: 'avca',
  AVNZ: 'avnz',
  AVSG: 'avsg',
  RAILBOOKER: 'railbookers',
  RBCA: 'rbca',
  RBAU: 'rbau',
  RBUS: 'rbus',
  RBNZ: 'rbnz',
  RBSG: 'rbsg',
}

export const parentBrands = {
  amtrak: 'AMTRAK',
  railbooker: 'RAILBOOKER',
}

export function isRailBookers() {
  return process.env.REACT_APP_PARENT_BRAND_CODE === parentBrands.railbooker
}

export const isNorthAmericanRegion = (brandId) => {
  return includes([clientIds.AMTRAK, clientIds.AVCA, clientIds.RBCA, clientIds.RBUS], clientIds[brandId])
}
